interface RoleInterface {
    id: number;
    name: string;
    description: string;
    level: number;
}

class Role implements RoleInterface {
    description: string;
    id: number;
    name: string;
    level: number;
}

export {
    RoleInterface,
    Role
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/roles/api.models.ts